import { Card, CardContent } from "@/components/ui/card";

export default function MeetTeam() {
  return (
    <div className="space-y-8" data-testid="meet-team-page">
      <div>
        <h1 className="text-3xl font-bold text-servify-dark-grey">Meet the Team</h1>
        <p className="text-servify-dark-grey/70 mt-2">
          Get to know the amazing people who make Servify what it is today
        </p>
      </div>
      
      <Card className="border-servify-white-grey shadow-lg backdrop-blur-sm bg-white rounded-lg overflow-hidden" data-testid="meet-team-card">
        <CardContent className="p-0">
          <div className="relative">
            <img 
              src="https://img-nonprod.servify.tech/Testing/team.png"
              alt="Meet the Servify Team"
              className="w-full h-auto object-cover"
              data-testid="team-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300">
              <div className="absolute bottom-4 left-4 text-white">
                <h3 className="text-xl font-bold">Our Team</h3>
                <p className="text-white/90">Here's a quick look at the team behind Servify's vision</p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}